import * as React from "react";

const GlobalContext = React.createContext({});

export default GlobalContext;
